import React from 'react';

import ModalBase from '../ModalBase/ModalBase';

function DeletePlaylistModal({
  isOpen,
  onClose,
  onConfirm,
  playlistName,
  deleting = false,
}) {
  const body = (
    <p className="delete-playlist-modal__text">
      Are you sure you want to delete{' '}
      <strong style={{ textTransform: 'uppercase' }}>
        &quot;{playlistName}&quot;
      </strong>
      ?
    </p>
  );

  const footer = (
    <>
      <button
        type="button"
        className="btn delete-playlist-modal__btn delete-playlist-modal__btn--cancel"
        onClick={onClose}
        disabled={deleting}
      >
        CANCEL
      </button>
      <button
        type="button"
        className="btn delete-playlist-modal__btn delete-playlist-modal__btn--confirm"
        onClick={onConfirm}
        disabled={deleting}
      >
        {deleting ? 'DELETING...' : 'CONFIRM'}
      </button>
    </>
  );

  return (
    <ModalBase
      isOpen={isOpen}
      toggle={!deleting ? onClose : undefined}
      header="Delete Playlist"
      body={body}
      footer={footer}
      className="delete-playlist-modal"
    />
  );
}

export default DeletePlaylistModal;
